import "./HoverGrid.scss";

import { LayoutGroup, motion } from "framer-motion";
import React, { useEffect, useState } from "react";

import { Logo } from "../../../Assets/Logos";
import Text from "../Text/Text";

interface HoverGridProps {
  images: Logo[];
}

const variants = {
  initial: (delay: number) => ({
    opacity: 0.5
  }),
  default: (delay: number) => ({
    opacity: 0.5,
    scale: 1,
    transition: {
      type: "spring",
      bounce: 0.5,
      duration: 1
    }
  }),
  hover: {
    opacity: 1,
    scale: 1.75,
    transition: {
      type: "spring",
      bounce: 0.5
    }
  }
};

export const HoverGrid: React.FC<HoverGridProps> = ({ images }) => {
  const [hovered, setHovered] = useState(-1);
  const [tapped, setTapped] = useState(-1);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTapped(-1);
    }, 5000);
    return () => clearInterval(intervalId);
  }, [tapped]);
  return (
    <div className="hg">
      <LayoutGroup>
        {images.map((image: Logo, idx) => (
          <motion.div
            className="hg-imageContainer"
            key={idx}
            custom={idx}
            variants={variants}
            initial="default"
            whileHover="hover"
            whileTap="hover"
            viewport={{ once: true }}
            animate={{
              scale: idx === tapped ? 1.75 : 1,
              opacity: idx === tapped ? 1 : 0.5
            }}
            onHoverStart={() => setHovered(idx)}
            onHoverEnd={() => setHovered(-1)}
            onTap={() => setTapped(idx === tapped ? -1 : idx)}
          >
            <motion.img className="hg-image" src={image.src} alt={image.name} />
            {(idx === hovered || tapped === idx) && (
              <Text className="hg-hoverText" p center noPadding>
                {image.name}
              </Text>
            )}
          </motion.div>
        ))}
      </LayoutGroup>
    </div>
  );
};

export default HoverGrid;
